const { default: axios } = require("axios");

const genreOfmovieFetchRequest = (genre_id, page) => {
  return {
    type: "GENRE_OF_MOVIE_FETCH_REQUEST",
    payload: { genre_id, page },
  };
};

const genreOfmovieFetchSuccess = (genre) => {
  return {
    type: "GENRE_OF_MOVIE_FETCH_SUCCESS",
    payload: genre,
  };
};

const genreOfmovieFetchFailure = (error) => {
  return {
    type: "GENRE_OF_MOVIE_FETCH_FAILURE",
    payload: error,
  };
};

const genreOfmovieFetch = ({ genre_id, page }) => {
  return (dispatch) => {
    dispatch(genreOfmovieFetchRequest({ genre_id, page }));
    axios({
      method: "GET",
      url: `/genres/${genre_id}/movies?page=${page}`,
    })
      .then((response) => {
        const genreOfmovie = response.data;
        dispatch(genreOfmovieFetchSuccess(genreOfmovie));
      })
      .catch((error) => {
        const errorMsg = error.message;
        dispatch(genreOfmovieFetchFailure(errorMsg));
      });
  };
};

export default genreOfmovieFetch;
